/**
 * Sort array of strings alphabeticaly (ascending).
 * @param {string[]|object[]} arr - Array containing strings to sort.
 * @param {string} [key] Object key to use during sort.
 * @return {string[]|null} Array containing sorted strings.
 */
export default function sortAlphabeticallyAsc(arr, key) {
  if (!(arr instanceof Array)) return null;
  return arr.sort((a, b) => {
    return typeof key === "string" 
      ? a[key].localeCompare(b[key])
      : a.localeCompare(b);
  });
}